import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconGridLayout$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGridLayout extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1ff851842c7ceba9bc97a9c5aa3750bad38db75d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a88e6f735e8fbbb0c09106819c559c729257c1bb', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'cf4e8278ebde0a3ff7c81494c56e91238122712c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4 4.5a.5.5 0 0 1 .5-.5H7a.5.5 0 0 1 .5.5V7a.5.5 0 0 1-.5.5H4.5A.5.5 0 0 1 4 7zm5.25 0a.5.5 0 0 1 .5-.5h2.5a.5.5 0 0 1 .5.5V7a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1-.5-.5zM15 4a.5.5 0 0 0-.5.5V7a.5.5 0 0 0 .5.5h2.5A.5.5 0 0 0 18 7V4.5a.5.5 0 0 0-.5-.5zM4 9.75a.5.5 0 0 1 .5-.5H7a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1-.5-.5zm5.75-.5a.5.5 0 0 0-.5.5v2.5a.5.5 0 0 0 .5.5h2.5a.5.5 0 0 0 .5-.5v-2.5a.5.5 0 0 0-.5-.5zm4.75.5a.5.5 0 0 1 .5-.5h2.5a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1-.5-.5zM7 18a.5.5 0 0 0 .5-.5V15a.5.5 0 0 0-.5-.5H4.5a.5.5 0 0 0-.5.5v2.5a.5.5 0 0 0 .5.5zm5.75-.5a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1-.5-.5V15a.5.5 0 0 1 .5-.5h2.5a.5.5 0 0 1 .5.5zm4.75.5a.5.5 0 0 0 .5-.5V15a.5.5 0 0 0-.5-.5H15a.5.5 0 0 0-.5.5v2.5a.5.5 0 0 0 .5.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-grid-layout", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-grid-layout"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-grid-layout":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGridLayout$1);
            }
            break;
    } });
}

const CosmosIconGridLayout = CosmosIconGridLayout$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGridLayout, defineCustomElement };
